export default function (section) {
	const list = section.querySelector('ul');
	const cards = [...list.children];
	const dots = [...section.querySelectorAll('.dots button')];
	const [previous, next] = section.querySelectorAll('.arrows button');
	let current = 0;

	// Centered in the list, by scrolling the list alone: the page stays where it is, even with the list partly out of sight.
	const goTo = (index) => {
		const card = cards[(index + cards.length) % cards.length];

		list.scrollTo({ left: card.offsetLeft - (list.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
	};

	// The card most in sight is the current one: its dot, the arrows at the ends, and the others dimmed (testimonials.css).
	const observer = new IntersectionObserver((entries) => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				current = cards.indexOf(entry.target);
			}
		}

		cards.forEach((card, i) => card.classList.toggle('current', i === current));
		dots.forEach((dot, i) => (i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
		previous.disabled = current === 0;
		next.disabled = current === cards.length - 1;
	}, { root: list, threshold: 0.6 });

	cards.forEach((card) => observer.observe(card));

	// Every few seconds the next one, round to the first, only while the list is in sight, until the visitor takes over: the current dot fills meanwhile, and its fill ending moves on.
	const stop = () => section.classList.remove('autoplay');

	section.classList.add('autoplay');
	new IntersectionObserver(([entry]) => section.classList.toggle('in-sight', entry.isIntersecting), { threshold: 0.5 }).observe(list);
	dots.forEach((dot) => dot.addEventListener('animationend', () => section.classList.contains('autoplay') && goTo(current + 1)));

	for (const type of ['pointerdown', 'wheel', 'keydown']) {
		list.addEventListener(type, stop, { passive: true });
	}

	dots.forEach((dot, i) => dot.addEventListener('click', () => {
		stop();
		goTo(i);
	}));
	previous.addEventListener('click', () => {
		stop();
		goTo(current - 1);
	});
	next.addEventListener('click', () => {
		stop();
		goTo(current + 1);
	});
}
